export const MAX_HISTORY_COUNT = 100
export const MAX_SWIPER_COUNT = 15
